<div id="map"></div>

<div class="map-item" #bubbleContent>
  <ng-container *ngComponentOutlet="currentBubble.component; inputs: currentBubble.inputs;">
  </ng-container>
</div>
